// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Results Page Styles */
.results-page {
  --results-type-heading: clamp(2.2rem, 3.2vw, 3.3rem);
  --results-type-body: 1.2rem;
  min-height: 100vh;
  padding: 6rem 0 4rem;
}

.page-hero {
  background: linear-gradient(135deg, var(--color-primary) 0%, #4a1548 100%);
  color: white;
  padding: 6rem 0 4rem;
  text-align: center;
}

.hero-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
}

.page-title {
  font-size: var(--results-type-heading);
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.page-subtitle {
  font-size: var(--results-type-body);
  line-height: 1.6;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .page-hero {
    padding: 4rem 0 3rem;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .page-subtitle {
    font-size: 1.125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Results/results.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0EAA0E;EAC1E,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Results Page Styles */\n.results-page {\n  --results-type-heading: clamp(2.2rem, 3.2vw, 3.3rem);\n  --results-type-body: 1.2rem;\n  min-height: 100vh;\n  padding: 6rem 0 4rem;\n}\n\n.page-hero {\n  background: linear-gradient(135deg, var(--color-primary) 0%, #4a1548 100%);\n  color: white;\n  padding: 6rem 0 4rem;\n  text-align: center;\n}\n\n.hero-container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.page-title {\n  font-size: var(--results-type-heading);\n  font-weight: 800;\n  line-height: 1.2;\n  margin-bottom: 1rem;\n}\n\n.page-subtitle {\n  font-size: var(--results-type-body);\n  line-height: 1.6;\n  opacity: 0.9;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n@media (max-width: 768px) {\n  .page-hero {\n    padding: 4rem 0 3rem;\n  }\n  \n  .page-title {\n    font-size: 2rem;\n  }\n  \n  .page-subtitle {\n    font-size: 1.125rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
